/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { FinanceDocumentSettings } from '@/data/web-api-client';
import repository from '@/services/repository';

const resource = '/Contracts';

export default {
    get(projectId: string) {
        return repository.get<IContractLineDto[]>(`${resource}?projectId=${projectId}`);
    },
    getSingle(documentNumber: string) {
        while (documentNumber.indexOf('/') !== -1) {
            documentNumber = documentNumber.replace('/', '-');
        }

        return repository.get<IContractDto>(`${resource}/${documentNumber}`);
    },
    getStatusOptions() {
        return [
            {value: 0, text: 'Open'},
            {value: 3, text: 'Verstuurd'},
            {value: 1, text: 'Aanvaard'},
            {value: 2, text: 'Afgewezen'},
        ];
    },
    create(command: IContractGenerateFromMeasuringstateCommand) {
        return repository.post<string>(`${resource}`, command);
    },
    update(command: IContractUpdateCommand) {
        let documentNumber = command.documentNumber;
        while (documentNumber.indexOf('/') !== -1) {
            documentNumber = documentNumber.replace('/', '-');
        }
        return repository.put<any>(`${resource}/${documentNumber}`, command);
    },
    delete(documentNumber: string) {
        while (documentNumber.indexOf('/') !== -1) {
            documentNumber = documentNumber.replace('/', '-');
        }
        return repository.delete(`${resource}/${documentNumber}`);
    },
    document: {
        download(documentNumber: string) {
            while (documentNumber.indexOf('/') !== -1) {
                documentNumber = documentNumber.replace('/', '-');
            }
            return repository
                .get<Blob>(`${resource}/${documentNumber}/Document`, { responseType: 'blob' });
        },
        upload(documentNumber: string, payload: IUploadChunkDto) {
            while (documentNumber.indexOf('/') !== -1) {
                documentNumber = documentNumber.replace('/', '-');
            }

            const formDataToUpload = new FormData();
            formDataToUpload.append('file', payload.file, payload.metaData.fileName);
            formDataToUpload.append('path', '');
            formDataToUpload.append('metaData[index]', '' + payload.metaData.index);
            formDataToUpload.append('metaData[totalCount]', '' + payload.metaData.totalCount);
            formDataToUpload.append('metaData[fileSize]', '' + payload.metaData.fileSize);
            formDataToUpload.append('metaData[fileName]', '' + payload.metaData.fileName);
            formDataToUpload.append('metaData[fileType]', '' + payload.metaData.fileType);
            formDataToUpload.append('metaData[fileGuid]', '' + payload.metaData.fileGuid);
            return repository.post<IUploadChunkResult>(`${resource}/${documentNumber}/uploadDocument`,
                formDataToUpload, {
                headers: {'Content-Type': 'multipart/form-data' },
            });
        },
        generate(documentNumber: string, settings: FinanceDocumentSettings) {
            while (documentNumber.indexOf('/') !== -1) {
                documentNumber = documentNumber.replace('/', '-');
            }
            return repository.post<any>(`${resource}/${documentNumber}/generateDocument`, settings);
        },
    },
    actions: {
        accept(documentNumber: string) {
            while (documentNumber.indexOf('/') !== -1) {
                documentNumber = documentNumber.replace('/', '-');
            }
            return repository.post<any>(`${resource}/${documentNumber}/accept`);
        },
        reject(documentNumber: string) {
            while (documentNumber.indexOf('/') !== -1) {
                documentNumber = documentNumber.replace('/', '-');
            }
            return repository.post<any>(`${resource}/${documentNumber}/reject`);
        },
        resetPrices(documentNumber: string) {
            while (documentNumber.indexOf('/') !== -1) {
                documentNumber = documentNumber.replace('/', '-');
            }
            return repository.post<any>(`${resource}/${documentNumber}/resetPrices`);
        },
        mail(command: IContractMailCommand) {
            let documentNumber = command.documentNumber;
            while (documentNumber.indexOf('/') !== -1) {
                documentNumber = documentNumber.replace('/', '-');
            }
            return repository.post(`${resource}/${documentNumber}/Mail`, command);
        },
    },
};
